import ImageZoom from './image-zoom/image-zoom.component';

export default ImageZoom;
export * from './image-zoom/image-zoom.type';
